import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../components/Courier.css";
import { hasPermission } from "../utils/permissions";

const CourierForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    category_detail: "",
  });

  const [loading, setLoading] = useState(false);
  const [canAdd, setCanAdd] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const pAdd = await hasPermission('master', 'addcategory');
        setCanAdd(!!pAdd);
      } catch {
        setCanAdd(false);
      }
    })();
  }, []);

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

   if (!formData.name.trim()) {
  toast.warn("⚠️ Category Name is required.");
  setLoading(false);
  return;
}


    try {
      const token = (localStorage.getItem('session_token') || '').trim();
      const url = `https://newerp.awasthivitality.com/api/category/add`;

      // Set up headers
      const headers = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
        headers['X-Session-Token'] = token;
      }

      const body = new FormData();
   body.append('name', formData.name.trim());

if (formData.category_detail.trim()) {
  body.append('category_detail', formData.category_detail.trim());
}

      // Add token as query parameter as fallback
      const urlWithToken = token ? `${url}?token=${encodeURIComponent(token)}` : url;

      const response = await fetch(urlWithToken, {
        method: "POST",
        headers: headers,
        body: body
      });

      let result;
      try {
        result = await response.json();
      } catch (parseError) {
        console.error('Failed to parse response:', parseError);
        toast.error("❌ Invalid response from server. Please try again.");
        setLoading(false);
        return;
      }

      console.log('API Response:', result);

      // Handle error responses
      if (!response.ok) {
        // Handle 403 - Permission Denied
        if (response.status === 403) {
          toast.error(`❌ Access Denied: ${result?.message || result?.msg || 'You do not have permission to add categories.'}`);
          setLoading(false);
          return;
        }
        
        // Handle 401 - Unauthorized
        if (response.status === 401) {
          toast.error("❌ Session Expired. Please login again.");
          localStorage.removeItem('session_token');
          localStorage.removeItem('user_data');
          setTimeout(() => window.location.href = '/', 2000);
          setLoading(false);
          return;
        }

        // Handle validation errors
        if (response.status === 422 && result.errors) {
          const errorMessages = Object.values(result.errors).flat().join(', ');
          toast.error(`❌ Validation Error: ${errorMessages}`);
          setLoading(false);
          return;
        }

        // Handle other errors
        const errorMsg = result?.message || result?.msg || result?.error || `HTTP ${response.status}: ${response.statusText}`;
        toast.error(`❌ Failed to add category: ${errorMsg}`);
        setLoading(false);
        return;
      }

      // Handle success
      if (result && result.success) {
        toast.success(result.msg || result.message || "Category added successfully!");
        setFormData({ name: "", category_detail: "" });

        // ✅ Redirect after short delay so toast is visible
        setTimeout(() => {
          navigate("/Category");
        }, 2000);
      } else {
        const errorMsg = result?.message || result?.msg || result?.error || 'Unknown error';
        toast.error(`❌ Failed to add category: ${errorMsg}`);
      }
    } catch (error) {
      console.error('Network/Request Error:', error);
      toast.error(`❌ Network Error: ${error.message || 'Please check your connection and try again.'}`);
    } finally {
      setLoading(false);
    }
  };

  if (!canAdd) {
    return (
      <div className="courier-page">
        <div className="courier-card">
          <div className="courier-card-header">Access Denied</div>
          <div style={{ padding: '20px', textAlign: 'center' }}>You do not have permission to add categories.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="courier-page">
      <div className="courier-card">
        <div className="courier-card-header">Add New Category</div>

        <form className="courier-form" onSubmit={handleSubmit}>
          <div className="courier-row">
            <div className="courier-field">
              <label>
                Category Name <span className="courier-required">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Category Name"
                required
              />
            </div>

            <div className="courier-field">
              <label>
                Category Details 
              </label>
              <input
                type="text"
                name="category_detail"
                value={formData.category_detail}
                onChange={handleChange}
                placeholder="Enter Details"
              />
            </div>
          </div>

          <button type="submit" className="courier-btn" disabled={loading}>
            {loading ? "Adding..." : "Add"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CourierForm;